var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEggcelent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45.6788,
    height: 45.6788,
    rx: 22.8394,
    fill: "#FFF5D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 25C33 31.6274 28.5228 35 23 35C17.4772 35 13 31.6274 13 25C13 18.3726 18.5 11 23 11C28 11 33 18.3726 33 25Z",
    fill: "#EDA10D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9384 10.2391L31.1252 14.6656C31.314 15.0475 31.724 15.268 32.1467 15.2148L37.2662 14.5703L33.531 17.8674C33.1924 18.1663 33.0962 18.6551 33.2963 19.06L35.4411 23.4014L30.8685 21.0631C30.5026 20.876 30.0595 20.9318 29.7514 21.2037L25.9012 24.6025L26.903 19.8649C26.9964 19.423 26.782 18.9733 26.3799 18.7677L21.9441 16.4993L27.0635 15.8548C27.4863 15.8015 27.8288 15.4863 27.917 15.0695L28.9384 10.2391Z",
    fill: "#FFF5D9",
    stroke: "#EDA10D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggcelent);
export default __webpack_public_path__ + "static/media/eggcelent.7b0ca3c2.svg";
export { ForwardRef as ReactComponent };